import { defineConfig } from "@biblioteksentralen/react";

export const customTheme = defineConfig({
  theme: {
    tokens: {
      fonts: {
        heading: { value: `var(--font-source-sans-3)` },
        body: { value: `var(--font-source-sans-3)` },
      },
    },
  },
});
